import BaseTrigger from "./baseTrigger";
import eventBus from "@/init/eventBus";

BaseTrigger.registerType("vueEvent", (options, callback) => {
  const { event } = options;

  if (!event) {
    console.error("Event argument is required for 'vueEvent' trigger");
    return false;
  }

  const handler = (...args) => {
    callback(...args);
  };

  eventBus.$on(event, handler);

  return () => {
    eventBus.$off(event, handler);
  };
});
